import React from 'react';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

const LoadingSpinner = ({
    size = 'large',
    message = 'Loading...',
    fullScreen = true,
    showMessage = true,
    className = '',
    variant = 'default' // default, elegant, minimal
}) => {
    const sizeClasses = {
        small: 'w-4 h-4',
        medium: 'w-8 h-8',
        large: 'w-12 h-12',
        xl: 'w-16 h-16'
    };

    const containerClasses = fullScreen
        ? "min-h-screen flex items-center justify-center bg-soft-50"
        : "flex items-center justify-center py-8";

    if (variant === 'elegant') {
        return (
            <div className={`${containerClasses} ${className}`}>
                <div className="text-center">
                    <div className="relative inline-flex items-center justify-center mb-6">
                        <div className={`absolute inset-0 rounded-full border-4 border-primary-200 animate-spin border-t-primary-600 ${sizeClasses[size]}`}></div>
                        <div className={`absolute inset-1 rounded-full border-2 border-primary-100 animate-spin border-t-primary-400 ${size === 'small' ? 'w-2 h-2' : size === 'medium' ? 'w-6 h-6' : size === 'large' ? 'w-10 h-10' : 'w-14 h-14'}`} style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
                        <ArrowPathIcon className={`text-primary-600 animate-pulse ${size === 'small' ? 'h-2 w-2' : size === 'medium' ? 'h-4 w-4' : size === 'large' ? 'h-6 w-6' : 'h-8 w-8'}`} />
                    </div>
                    {showMessage && (
                        <>
                            <h3 className={`font-semibold text-soft-900 mb-2 ${size === 'small' ? 'text-sm' : size === 'medium' ? 'text-base' : 'text-lg'}`}>
                                {typeof message === 'string' ? message : 'Loading...'}
                            </h3>
                            <div className="flex items-center justify-center space-x-2 mb-4">
                                <div className="w-2 h-2 bg-primary-400 rounded-full animate-bounce"></div>
                                <div className="w-2 h-2 bg-primary-400 rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                                <div className="w-2 h-2 bg-primary-400 rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
                            </div>
                            <p className="text-soft-600 text-sm animate-pulse">Please wait while we process your request...</p>
                        </>
                    )}
                </div>
            </div>
        );
    }

    if (variant === 'minimal') {
        return (
            <div className={`${containerClasses} ${className}`}>
                <div className="flex items-center space-x-3">
                    <div className={`animate-spin rounded-full border-2 border-primary-200 border-t-primary-600 ${sizeClasses[size]}`}></div>
                    {showMessage && <span className="text-soft-600 font-medium">{message}</span>}
                </div>
            </div>
        );
    }

    // Default variant - enhanced version
    return (
        <div className={`${containerClasses} ${className}`}>
            <div className="text-center">
                <div className="relative inline-flex items-center justify-center mb-4">
                    <div className={`animate-spin rounded-full border-4 border-primary-200 border-t-primary-600 ${sizeClasses[size]}`}></div>
                </div>
                {showMessage && (
                    <>
                        <h3 className={`font-medium text-soft-900 mb-2 ${size === 'small' ? 'text-sm' : size === 'medium' ? 'text-base' : 'text-lg'}`}>
                            {message}
                        </h3>
                        <div className="inline-flex items-center space-x-2 bg-white/80 px-4 py-2 rounded-full border border-primary-200/50 shadow-sm">
                            <div className="animate-spin rounded-full h-3 w-3 border-2 border-primary-300 border-t-primary-600"></div>
                            <span className="text-soft-600 text-sm font-medium animate-pulse">Processing...</span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default LoadingSpinner; 